<template>
<div v-if="dataLoaded">
    <table-page
        :client="client"
        @updated="getData"
        :warnings="warnings"
        :changelogs="changelogs"
    >
        <fast-table
            :recordLabel="recordLabel"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentRowId"
            @click="currentRowId = $event.id"
        >
            <template v-slot:table-actions>
                <button class="btn btn-primary btn-collapse" id="addButton" @click="addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Bank Account</span>
                </button>
            </template>
        </fast-table>

        <add-form-modal
            v-if="addModalOpen"
            :client="client"
            @updated="getData"
            @close="addModalOpen = false"
        />
    </table-page>

    <sidebar
        v-if="currentRowId"
        :client="client"
        :bank-account-id="currentRowId"
        @updated="getData"
        @close="currentRowId = null"
    >
    </sidebar>
</div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import Sidebar from './components/BankAccounts/Sidebar'
import AddFormModal from './components/BankAccounts/AddFormModal'

export default {
    components: {FastTable, Sidebar, AddFormModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        alphabeticalCompanies() {
            return this.client.companies.slice().sort((a, b) => a.name.localeCompare(b.name))
        },
        currentRow() {
            return this.bankAccounts.find(x => (x.id == this.currentRowId))
        },
        sections() {
            return [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: false},
            ]
        },
        tableData() {
            const tableData = []

            const sections = [
                this.bankAccounts.filter(obj => obj.is_active),
                this.bankAccounts.filter(obj => !obj.is_active),
            ]

            sections.forEach((section, idx) => {
                const sectionData = []

                section.forEach(obj => {
                    const company = this.client.companies.find(c => c.id == obj.company_id)
                    sectionData.push({
                        id: obj.id,
                        object: obj,
                        cells: [
                            obj.name,
                            company.name,
                            obj.bank_name,
                            obj.account_number_last_4,
                            obj.is_default_billing,
                            obj.is_default_net_pay,
                            obj.is_default_taxes,
                            obj.public_id,
                        ],
                    })
                })

                tableData.push(sectionData)
            })

            return tableData
        },
    },
    data() {
        return {
            bankAccounts: [],
            dataLoaded: false,
            currentRowId: null,
            recordLabel: "Bank accounts",
            headers: [
                {label: 'Bank Account', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Company', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Institution', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Account Number', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Default Billing', type: 'checkmark', classes: 'cell-icon', isSearchable: false, isFilterable: true},
                {label: 'Default Net Pay', type: 'checkmark', classes: 'cell-icon', isSearchable: false, isFilterable: true},
                {label: 'Default Taxes', type: 'checkmark', classes: 'cell-icon', isSearchable: false, isFilterable: true},
                {label: 'ID', classes: 'cw-18', type: "copy", isFilterable: false, isSearchable: false, defaultSort: false},
            ],
            addModalOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Bank Accounts')
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/bank-accounts`).then(resp => {
                this.dataLoaded = true
                this.bankAccounts = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
    },
}
</script>
